"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Maybe = void 0;
const ramda_1 = require("ramda");
const noneObj = { hasValue: false };
class Maybe {
    static And(values) {
        const returnValue = [];
        for (const i of values) {
            if (!i.hasValue) {
                return Maybe.none();
            }
            returnValue.push(i.value);
        }
        return Maybe.some(returnValue);
    }
}
exports.Maybe = Maybe;
Maybe.isSome = (m) => m.hasValue;
Maybe.isNone = (m) => !m.hasValue;
Maybe.map = (f) => (m) => m.hasValue ? Maybe.some(f(m.value)) : m;
Maybe.orElse = (defaultValue) => (m) => m.hasValue ? m : Maybe.some(defaultValue);
Maybe.flatMap = (f) => (m) => m.hasValue ? f(m.value) : m;
Maybe.join = (m) => (m.hasValue ? m.value : null);
Maybe.filter = (f) => (m) => m.hasValue && f(m.value) ? m : noneObj;
Maybe.filterType = (f) => (m) => Maybe.filter(f)(m);
Maybe.cata = (nf) => (f) => (m) => m.hasValue ? f(m.value) : nf();
Maybe.chain = (f) => (m) => Maybe.join(Maybe.map(f)(m));
Maybe.orSome = (val) => (m) => ramda_1.pipe(Maybe.orElse(val), v => v.value)(m);
Maybe.some = (value) => ({
    hasValue: true,
    value,
});
Maybe.none = () => noneObj;
Maybe.fromValue = (value) => value === undefined || value === null ? noneObj : Maybe.some(value);
Maybe.fromArray = (array) => array.length === 1 ? Maybe.some(array[0]) : Maybe.none();
Maybe.toArray = (maybe) => Maybe.isSome(maybe) ? [maybe.value] : [];
//# sourceMappingURL=Maybe.js.map